import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { message, Spin, Result, Button } from 'antd';
import { spCommonCallBack, tkShopCallBack } from '@/api/shop/shop';

const ShopeCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('processing');
  const [result, setResult] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const code = searchParams.get('code');
        const shopId = searchParams.get('shop_id');
        const platformType = searchParams.get('platformType');
        console.log('code:', code);

        if (!code) {
          setErrorMessage('检查重新授权');
          setStatus('error');
          setLoading(false);
          return;
        }

        const params = {
          code:code,
          // shopId: shopId
        };
        const shopeParams = {
          data:{
            shopId: shopId,
            code: code
          },
          code: 1
        };

        let apiResult;
        if (platformType === 'SHOPEE') {
          // 调用虾皮回调接口
          const spResult = await spCommonCallBack(shopeParams);
          apiResult = spResult;
        } else {
          // 调用tk回调接口
          const tkResult = await tkShopCallBack(params);
          apiResult = tkResult;
        }
        console.log('apiResult', apiResult);
        if (apiResult && apiResult.code === '0') {
          setResult(apiResult);
          setStatus('success');
          message.success('授权成功');
        } else {
          setErrorMessage(apiResult?.message || '授权失败');
          setStatus('error');
          message.error(apiResult?.message || '授权失败');
        }
      } catch (error) {
        console.error('授权回调处理失败:', error);
        setErrorMessage(error.message || '授权回调处理失败');
        setStatus('error');
        message.error('授权回调处理失败');
      } finally {
        setLoading(false);
      }
    };

    handleCallback();
  }, [location.search]);

  const handleBack = () => {
    navigate('/ecplatform/commodity/shop/my');
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" tip="正在处理授权回调..." />
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '80vh' 
    }}>
      {status === 'success' ? (
        <Result
          status="success"
          title="授权成功!"
          subTitle="店铺授权已完成，您可以返回继续操作。"
          extra={[
            <Button type="primary" key="console" onClick={handleBack}>
              返回我的店铺
            </Button>,
            <Button 
              key="detail" 
              onClick={() => {
                console.log('详细结果:', result);
              }}
            >
              查看详情
            </Button>
          ]}
        />
      ) : (
        <Result
          status="error"
          title="授权失败"
          subTitle={errorMessage}
          extra={[
            <Button type="primary" key="retry" onClick={() => window.location.reload()}>
              重试
            </Button>,
            <Button key="back" onClick={handleBack}>
              返回我的店铺
            </Button>
          ]}
        />
      )}
    </div>
  );
};

export default ShopeCallback;